import {getToken} from "@/composables/auth";
import {exit} from "@/composables/functionExit";
import {changeLoadApp, changeShow, goLkPage, setProject} from "@/composables/ModuleCommunication";
import {projectDisabledModules} from "@/composables/constans/modules";
import {useUser} from "@/store/user";
import {useProjects} from "@/store/projects";
import {useStore} from "@/store";
import {useGlobusLocal, t} from "@/controllerLK/GlobusLocalization";
import {isTestDomain} from "@/composables/constans/testDomain";

import {ProjectHasntModule} from "@/router";
import {
    verifySubscription
} from "@/pages/LKPage/LKWindow/LKProjectWindow/ProjectModal/TelegramNotifications/useTelegramRules";

export const personalAreaInitialize = async () => {

    const store = useStore();
    const userStore = useUser();
    const projectStore = useProjects();
    const { initGlobusLocal } = useGlobusLocal();

    try {
        const token = await getToken();

        if (token) {
            const currentUser = await userStore.getUser();
            let hasAccess = !!currentUser;

            // isTestDomain проекты почему-то тоже числятся как часть module_globus

            if (hasAccess && store.activeModule.dataName === "module_globus" && !isTestDomain) {
                const organizationMembers = await userStore.getOrganizationMembers();
                hasAccess = !!organizationMembers;
            }

            if (!hasAccess) {
                await exit();
                store.createNotify(t("login_page.error.no_access"), "error");
                return false;
            }

            if (!userStore.user.modules.find(item => item.moduleId === store.activeModule.dataName)
                && !["module_proxy", "module_sources"].includes(store.activeModule.dataName) ) {
                await exit();
                store.createNotify("У данного пользователя нет доступа к модулю, обратитесь к администратору", "error");
                store.loader = false;
                return;
            }

            if (userStore.user.language.toLowerCase() !== localStorage.getItem("globusLanguage")) {
                localStorage.setItem("globusLanguage", userStore.user.language.toLowerCase());
                window.location.reload();
            }

            initGlobusLocal(userStore.user.language.toLowerCase(), "personal_area");

            // Проверка авторизации ТГ бота для уведомлений.

            await verifySubscription();

            if (userStore.user.activeProject) {
                if (isTestDomain || store.activeModule.dataName !== "module_globus") {
                    changeLoadApp(true);
                    store.loader = false;
                    return changeShow(true);
                }
                await projectStore.getProjects();

                let project = await projectStore.getProject(userStore.user.activeProject);

                if (project) {
                    projectStore.activeProject = project;
                    setProject(project);

                    changeLoadApp(true);
                    changeShow(true);

                    if (projectStore.activeProject.modules
                        && !projectStore.activeProject?.modules.includes(store.activeModule.dataName)
                        && !projectDisabledModules.includes(store.activeModule.dataName)) {
                        await ProjectHasntModule();
                    }
                }
            } else if (userStore.user.modules.some((module) => module.moduleId === "module_globus" && !isTestDomain)) {
                await projectStore.getProjects();
            } else {
                changeLoadApp(false);
                changeShow(false);
            }

            if (projectStore.projects.length === 0 && !isTestDomain) {
                store.createNotify(t("toast.error.no_project"), "error");
                localStorage.setItem("lk_tab", "projects");
                await goLkPage();
            }

            if (userStore.user.activeProject === 0) {
                projectStore.activeProject = projectStore.projects[0];
                setProject(projectStore.projects[0]);
                changeLoadApp(true);
                changeShow(true);
            }
        }
    } catch(e){
        console.log(e);
    }
    store.loader = false;
};